/**
 * Request timeout in milliseconds was increased to 120 seconds
 * because IMS Wallet requested to increase it for
 * Get Bonus History and Get Balance history requests
 */
export const REQUEST_TIMEOUT = 120000;
export const BATCH_REQUEST_ID = 35508;
